<script setup lang="ts">
    import { type Table } from '@tanstack/table-core';
    import { Checkbox } from '@/components/ui/checkbox';

    const props = defineProps<{
        table: Table<any>;
    }>();
</script>

<template>
    <Checkbox
        :model-value="
            table.getIsSomePageRowsSelected() ? 'indeterminate' : table.getIsAllPageRowsSelected()
        "
        @update:model-value="(value) => table.toggleAllPageRowsSelected(!!value)"
        aria-label="Select all"
    />
</template>
